import { EditIcon } from '../../icons';

import Button, { type IButtonProps } from './Button';

export interface IEditButtonProps extends Omit<IButtonProps, 'iconLeading' | 'iconTrailing'> {
  /** Accessible label. Defaults to "Edit" when icon-only; redundant (and omitted) when a text label is passed as children. */
  'aria-label'?: string;
}

/**
 * Edit button — a thin preset over {@link Button} fixed to the edit (pencil)
 * icon. Icon-only by default (borderless `link-gray` at `xs`, accessible name
 * "Edit"); pass children to render a leading pencil + text label instead. Every
 * other Button prop (`color`, `size`, `onClick`, `className`, `isDisabled`, …)
 * passes through, so callers can restyle or attach context-specific
 * hover-reveal classes via `className`.
 */
const EditButton = ({
  color = 'link-gray',
  size = 'xs',
  children,
  'aria-label': ariaLabel,
  ...props
}: IEditButtonProps) => (
  <Button
    {...props}
    color={color}
    size={size}
    iconLeading={EditIcon}
    aria-label={ariaLabel ?? (children ? undefined : 'Edit')}
  >
    {children}
  </Button>
);

export default EditButton;
